import React, { useEffect } from 'react';
import { HiArrowLeft, HiCalendar, HiShare, HiTag, HiClock } from 'react-icons/hi2';

const BlogPost = ({ article, onBack }) => {
    useEffect(() => {
        if (article?.title) {
            // SEO Meta Dynamic Update
            document.title = `${article.title} - Semesta Cafe`;
            
            // Meta description update if exists
            let metaDesc = document.querySelector('meta[name="description"]');
            if (metaDesc) {
                metaDesc.setAttribute('content', article.seoDescription || article.title);
            }
        }
        window.scrollTo(0, 0);

        return () => {
            document.title = 'Semesta Cafe';
        };
    }, [article]);

    if (!article) return null;

    const handleShare = () => {
        if (navigator.share) {
            navigator.share({
                title: article.title,
                text: article.seoDescription || article.title,
                url: window.location.href
            }).catch(() => {});
        } else {
            navigator.clipboard.writeText(window.location.href);
            alert("Link artikel telah disalin ke clipboard!");
        }
    };

    // Calculate reading time (approx 200 words per minute)
    const wordCount = article.content ? article.content.split(/\s+/).length : 0;
    const readTimeMinutes = Math.max(1, Math.ceil(wordCount / 200));

    return (
        <article className="max-w-4xl mx-auto px-4 py-8">
            {/* NAVIGASI BACK & SHARE */}
            <div className="flex items-center justify-between mb-6">
                <button
                    onClick={onBack}
                    className="flex items-center gap-2 text-sm font-semibold text-gray-600 hover:text-green-700 transition-colors bg-white px-4 py-2 rounded-full border border-gray-200 shadow-sm"
                >
                    <HiArrowLeft className="w-4 h-4" /> Kembali ke Blog
                </button>
                <button
                    onClick={handleShare}
                    className="flex items-center gap-2 text-sm font-semibold text-gray-600 hover:text-green-700 transition-colors bg-white px-4 py-2 rounded-full border border-gray-200 shadow-sm"
                >
                    <HiShare className="w-4 h-4" /> Bagikan
                </button>
            </div>

            {/* ARTICLE HEADER */}
            <header className="space-y-4 mb-8">
                <div className="flex items-center gap-3">
                    <span className="bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                        {article.category || 'Umum'}
                    </span>
                    <span className="flex items-center gap-1 text-xs text-gray-500">
                        <HiClock className="w-3.5 h-3.5" /> {readTimeMinutes} menit baca
                    </span>
                </div>

                <h1 className="text-2xl md:text-4xl font-extrabold text-gray-900 leading-tight">
                    {article.title}
                </h1>

                <div className="flex items-center gap-4 text-xs text-gray-500 border-b border-gray-100 pb-4">
                    <div className="flex items-center gap-1.5">
                        <HiCalendar className="w-3.5 h-3.5" />
                        <time dateTime={article.createdAt?.toDate ? article.createdAt.toDate().toISOString() : ''}>
                            {article.createdAt?.toDate
                                ? article.createdAt.toDate().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })
                                : 'Baru Saja'}
                        </time>
                    </div>
                    <span>•</span>
                    <span>Oleh Admin Semesta Cafe</span>
                </div>
            </header>

            {/* COVER IMAGE */}
            {article.coverImage && (
                <div className="mb-8 rounded-2xl overflow-hidden shadow-md border border-gray-100">
                    <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full max-h-[450px] object-cover"
                    />
                </div>
            )}

            {/* ARTICLE CONTENT */}
            <main className="prose prose-green max-w-none text-gray-800 leading-relaxed text-base space-y-4 font-sans">
                {article.content ? (
                    // Rendering content (supporting HTML tags or fallback to paragraph breaks)
                    article.content.includes('<p>') || article.content.includes('<div>') || article.content.includes('<h2>') ? (
                        <div dangerouslySetInnerHTML={{ __html: article.content }} />
                    ) : (
                        article.content.split('\n\n').map((paragraph, index) => (
                            <p key={index} className="text-gray-700 leading-relaxed">
                                {paragraph}
                            </p>
                        ))
                    )
                ) : (
                    <p className="text-gray-400 italic">Belum ada konten artikel.</p>
                )}
            </main>

            {/* ARTICLE FOOTER / CTA */}
            <footer className="mt-12 pt-8 border-t border-gray-200">
                <div className="bg-gradient-to-r from-green-800 to-emerald-900 text-white rounded-2xl p-6 md:p-8 text-center space-y-4 shadow-lg">
                    <h3 className="text-xl font-bold">Tertarik mencoba menu favorit di Semesta Cafe?</h3>
                    <p className="text-sm text-green-100 max-w-xl mx-auto">
                        Pesan langsung lewat aplikasi pelanggan Semesta Cafe untuk mendapatkan poin dan diskon menarik!
                    </p>
                    <button
                        onClick={onBack}
                        className="px-6 py-2.5 bg-white text-green-800 font-bold rounded-full text-sm hover:bg-green-50 transition-colors shadow-md inline-block"
                    >
                        Lihat Menu & Pesan Sekarang
                    </button>
                </div>
            </footer>
        </article>
    );
};

export default BlogPost;
